import { render, staticRenderFns } from "./UcPaymentTransactionTypeSymbol.yaml?vue&type=template&id=1617e8f3&component"
import script from "./UcPaymentTransactionTypeSymbol.yaml?vue&type=script&lang=ts&component"
export * from "./UcPaymentTransactionTypeSymbol.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports